import { App } from "./ui/App.ts";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    (globalThis as any).app = new App();
  });
} else {
  (globalThis as any).app = new App();
}
